import { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import Ico from "../components/Icons";
import useReveal from "../hooks/useReveal";
import SERVICES from "../data/services";

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = SERVICES.find(s => s.slug === slug);
  useReveal();

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!service) return <Navigate to="/services" replace />;
  if (service.isPackRedirect) return <Navigate to="/packs" replace />;

  const others = SERVICES.filter(s => s.slug !== slug && !s.isPackRedirect);

  return (
    <div className="pagewrap">
      <section className="sec" style={{ background: "var(--w)" }}>
        <div className="secinr">
          <Link className="svcback r" to="/services">
            <span style={{ display: "inline-flex", transform: "rotate(180deg)" }}><Ico name="arrowR" size={13} /></span>
            Tous les services
          </Link>

          <div className="r">
            <div className="svchead">
              <div className="svcheadicon"><Ico name={service.ico} size={28} color="#fff" /></div>
              <div>
                <div className="lbl" style={{ marginBottom: ".3rem" }}><span className="lblline" />Service</div>
                <h1 className="sh2" style={{ marginBottom: 0 }}>{service.name}</h1>
              </div>
            </div>
            <p className="slead" style={{ maxWidth: 620 }}>{service.tagline}</p>

            <div className="svcbody">
              {service.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
            </div>

            {service.idealFor.length > 0 && (
              <>
                <div className="lbl" style={{ marginTop: "2rem" }}><span className="lblline" />Idéal pour</div>
                <div className="chiprow">
                  {service.idealFor.map(f => <span className="chip" key={f}>{f}</span>)}
                </div>
              </>
            )}
          </div>

          {/* CE QUI EST INCLUS */}
          <div className="sechdr r" style={{ marginTop: "3.5rem", transitionDelay: ".1s" }}>
            <div className="lbl"><span className="lblline" />Ce qui est inclus</div>
            <h2 className="sh2">Au <em>programme</em></h2>
          </div>
          <div className="aboutgrid r" style={{ transitionDelay: ".15s", gap: "1.4rem", alignItems: "start" }}>
            <div className="srvc">
              <div className="srvfeats" style={{ marginTop: 0 }}>
                {service.features.map(f => (
                  <div className="srvfeat" key={f} style={{ fontSize: ".88rem" }}>
                    <Ico name="check" size={14} color="var(--blue-m)" />{f}
                  </div>
                ))}
              </div>
            </div>

            {service.benefits.length > 0 && (
              <div className="valcards">
                {service.benefits.map(b => (
                  <div className="valc" key={b.t}>
                    <div className="valico"><Ico name="sparkle" size={17} color="#fff" /></div>
                    <div className="valtxt"><strong>{b.t}</strong><span>{b.d}</span></div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* CTA */}
          <div className="ctaband r" style={{ transitionDelay: ".2s" }}>
            <div>
              <h3>Envie d'en discuter ?</h3>
              <p>Parlons de votre besoin autour de « {service.name} » : le premier échange est gratuit et sans engagement.</p>
            </div>
            <Link className="ctabtn" to={`/contact?sujet=${service.slug}`}>Demander un devis <Ico name="arrowR" size={15} color="var(--blue)" /></Link>
          </div>

          {/* AUTRES SERVICES */}
          <div className="sechdr r" style={{ marginTop: "3.5rem" }}>
            <div className="lbl"><span className="lblline" />À découvrir aussi</div>
            <h2 className="sh2">Autres <em>services</em></h2>
          </div>
          <div className="otherwrap r">
            {others.map(s => (
              <Link className="otherlink" to={`/services/${s.slug}`} key={s.slug}>
                <Ico name={s.ico} size={15} color="var(--blue-m)" />{s.name}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}